export const copyToClipboard = async (domElement) => {
    if (!domElement) return

    const text = domElement.innerText ?? domElement.textContent

    if (navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text)
            return
        } catch (err) {
            console.warn('Clipboard API failed, falling back', err)
        }
    }

    const textarea = document.createElement('textarea')
    textarea.value = text
    textarea.style.position = 'fixed'
    textarea.style.opacity = '0'
    document.body.appendChild(textarea)
    textarea.focus()
    textarea.select()

    try {
        document.execCommand('copy')
    } finally {
        document.body.removeChild(textarea)
    }
}
